export const nuxtTypeComposable = 'TComposable';
export const nuxtTypeDefault = 'DefaultT';
export const nuxtTypeResponse = 'ResT';

export const sdkId = 'sdk';
